import { render } from "./PostDetailPage.vue?vue&type=template&id=3f672fc8&scoped=true"
import script from "./PostDetailPage.vue?vue&type=script&lang=ts"
export * from "./PostDetailPage.vue?vue&type=script&lang=ts"

import "./PostDetailPage.vue?vue&type=style&index=0&id=3f672fc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f672fc8"

export default script